import o from"../internals/export.js";import t from"../internals/array-from.js";import a from"../internals/check-correctness-of-iteration.js";var e=o,f=t,m=a,c=!m(function(r){Array.from(r)});e({target:"Array",stat:!0,forced:c},{from:f});
